import type { User } from '@/types/user/type';
import { UserTypeEnum } from '~/model/UserType';

export const isGuestUser = (user: Partial<User>) =>
  user?.['@id'] && user?.['@type'] === UserTypeEnum.GUEST_USER;

export const isMainUser = (user: Partial<User>) =>
  user?.['@id'] && user?.['@type'] === UserTypeEnum.USER;
